import { useEffect, useState } from "react";
import { Users, Trophy } from "lucide-react";
import { getInvites } from "@/lib/membership";

// Amici portati su Readoo col link Founder + classifica tra Founder. Nessun premio: solo riconoscimento.
export function FounderInvites({ user }) {
  const [d, setD] = useState(null);
  useEffect(() => { if (user.founder) getInvites().then(setD).catch(() => {}); }, [user.founder]);
  if (!user.founder || !d) return null;
  const pct = d.next_goal ? Math.round((d.count * 100) / d.next_goal) : 100;
  return (
    <div data-testid="founder-invites" className="mt-6 rounded-2xl border border-hair bg-surfaceSecondary p-5 sm:p-6">
      <div className="flex items-center gap-2 mb-3">
        <Users size={18} className="text-brand" />
        <h2 className="text-base font-semibold text-onSurface">I tuoi inviti</h2>
      </div>
      <p data-testid="founder-invites-count" className="font-serif text-2xl font-semibold text-onSurface">
        {d.count === 0 ? "Nessun amico ancora" : `Hai portato ${d.count} ${d.count === 1 ? "amico" : "amici"} su Readoo`}
      </p>
      {d.next_goal && (
        <>
          <p data-testid="founder-invites-goal" className="mt-1 text-sm text-onSurfaceSecondary">
            {d.count === 0 ? "Condividi il tuo link: chi si registra da lì conta qui." : `Ne mancano ${d.next_goal - d.count} per arrivare a ${d.next_goal}.`}
          </p>
          <div className="mt-3 h-2 rounded-full bg-hair overflow-hidden"><div className="h-full bg-brand transition-[width] duration-700" style={{ width: `${pct}%` }} /></div>
        </>
      )}
      {d.ranking.length > 0 && (
        <div data-testid="founder-ranking" className="mt-6">
          <p className="flex items-center gap-1.5 text-xs font-mono uppercase tracking-wider text-subtle mb-2"><Trophy size={13} /> Classifica Founder</p>
          <ol className="divide-y divide-hair">
            {d.ranking.map((r, i) => (
              <li key={i} data-testid={`founder-ranking-row-${i}`} className={`flex items-center gap-3 py-2 text-sm ${r.me ? "text-brand font-semibold" : "text-onSurface"}`}>
                <span className="w-6 font-mono text-xs text-subtle">{i + 1}</span>
                <span className="flex-1">{r.name}{r.me ? " · tu" : ""}</span>
                <span className="font-mono tabular-nums">{r.count}</span>
              </li>
            ))}
          </ol>
          {d.rank && d.rank > 10 && <p data-testid="founder-my-rank" className="mt-2 text-xs text-subtle">Sei al {d.rank}° posto.</p>}
        </div>
      )}
      <p className="mt-4 text-[11px] text-subtle">La classifica mostra nome e iniziale del cognome ed è visibile solo ai Founder. Non prevede premi.</p>
    </div>
  );
}
